import colors from '@sportninja/common/constants/appColors'

/**
 * The six-dot grip, as raw SVG markup.
 *
 * The tree rail renders antd's `<HolderOutlined />` component directly, but AG
 * Grid's `icons` option takes an HTML STRING — it injects the markup itself
 * rather than rendering a React node. This is the same glyph antd ships
 * (`@ant-design/icons-svg` `HolderOutlined`), inlined so the rail and the grid
 * show one identical grip instead of AG Grid's own unrelated drag icon.
 *
 * Keep the path in sync with antd's if that dependency is ever upgraded; it is
 * a stable icon, and the alternative — rendering a React component to a string
 * at runtime — costs more than it saves for one glyph.
 */
const HOLDER_PATH =
  'M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z'

/** `icons.rowDrag` for AG Grid — the same grip the tree rail shows. */
export const rowDragIcon = (): string =>
  `<svg viewBox="64 64 896 896" width="1em" height="1em" fill="${colors.NEUTRAL_100}" aria-hidden="true" focusable="false"><path d="${HOLDER_PATH}"/></svg>`
